__turbopack_context__.v({
  "body": "ArticleItemBody-module-scss-module__NEXIEG__body",
});
